var _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMMylocationTemp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "url(#paint0_radial_13959_449402)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "white",
    stroke: "#FA1C44",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 4.71216L5.32502 13.2872L9.00002 10.9291L12.675 13.2872L9.00002 4.71216Z",
    fill: "#FA1C44"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13959_449402",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9 9) rotate(90) scale(9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510833,
    stopColor: "#2E66F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#769DFF",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMMylocationTemp);
export default __webpack_public_path__ + "static/media/m_mylocation_temp.50ff589a1830fa1712cb9f40d549e801.svg";
export { ForwardRef as ReactComponent };